function deleteUserNoMovimentationDialog () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/delete-user-no-movimentation/delete-user-no-movimentation-dialog.html?$$REVISION$$'
  }
}

export { deleteUserNoMovimentationDialog }
